var default_domain = 'http://192.168.5.100:7081'; // 本地域名
if((window.location.host).indexOf('edgteam.cn') != -1) {
	default_domain = 'http://api.edgteam.cn:8080';
}

function request(method, ops) {
	var options = $.extend({
		url: "/",
		params: {},
		typeData: "json",
		async: true,
		contentType: 'application/x-www-form-urlencoded',
		domain: default_domain,
		callback: function(responseData) {},
		loadStart: function() {
			//			$.AMUI.progress.start();
		},
		loadDone: function() {
			//			$.AMUI.progress.done();
		}
	}, ops || {});

	/*	console.log('请求参数：', {
			'url': options.url,
			'params': options.params
		});*/

	//加载进度条
	options.loadStart();

	$.ajax({
		type: method,
		url: options.domain + options.url,
		data: options.params,
		timeout: 15000,
		async: options.async,
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		dataType: options.typeData,
		beforeSend: function(xhr) {
			// xhr.setRequestHeader("Cookie",'token='+window.localStorage.getItem("token"));
			if(options.contentType) {
				xhr.setRequestHeader("Content-Type", options.contentType);

			}
		},
		success: function(data) {
			if(data == null) {
				options.callback(data);
				return;
			}
			if(typeof data.code === 'undefined') {
				options.callback(data);
			} else if(data.code == 0 || data.code == 4) {
				options.callback(data);
			} else {
				alert(data.message);
			}
		},
		error: function(xhr, status) {
			// console.log('ddddddd:',status)
			if(xhr.status != 0) {
				if(JSON.parse(xhr.responseText).message)
					alert(JSON.parse(xhr.responseText).message);
				return;
			}
			// alert('请求“' + options.url + '”服务器没有响应！');
		},
		complete: function() {
			//结束进度条
			options.loadDone();
		}
	});
}

export default class Request {
	constructor() {

	}

	get(options) {
		request('get', options);
	}

	post(options) {
		request('post', options);
	}

	put(options) {
		request('put', options);
	}

	delete(options) {
		request('delete', options);
	}

	patch(options) {
		request('patch', options);
	}
}



// WEBPACK FOOTER //
// ./src/js/request.js